import _IconClose from "@arco-design/web-react/icon/react-icon/IconClose";
import _IconPushpin from "@arco-design/web-react/icon/react-icon/IconPushpin";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";
import React, { useState, useEffect, useRef } from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import useLocale from '@/utils/useLocale';
import styles from './style/index.module.less';
const ITEM_TYPE = 'TAB';
function TabBar() {
  const t = useLocale();
  const dispatch = useDispatch();
  const history = useHistory();
  const tabs = useSelector(state => state.tabs) || [];
  const activeTab = useSelector(state => state.activeTab) || '';
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    tabKey: ''
  });

  // 点击标签页切换路由
  const handleTabClick = tab => {
    dispatch({
      type: 'set-active-tab',
      payload: {
        key: tab.key
      }
    });
    history.push(`/${tab.key}`);
  };

  // 关闭标签页
  const handleClose = (e, tab) => {
    e.stopPropagation();
    if (!tab.closable) return;
    dispatch({
      type: 'remove-tab',
      payload: {
        key: tab.key
      }
    });
    if (activeTab === tab.key) {
      const remainingTabs = tabs.filter(t => t.key !== tab.key);
      if (remainingTabs.length > 0) {
        const lastTab = remainingTabs[remainingTabs.length - 1];
        history.push(`/${lastTab.key}`);
      } else {
        history.push('/');
      }
    }
  };

  // 右键菜单
  const handleContextMenu = (e, tabKey) => {
    e.preventDefault();
    e.stopPropagation();
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      tabKey
    });
  };

  // 关闭右键菜单
  const closeContextMenu = () => {
    setContextMenu(prev => ({
      ...prev,
      visible: false
    }));
  };
  useEffect(() => {
    const handleClick = () => closeContextMenu();
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  // 右键菜单操作
  const handleCloseCurrent = () => {
    const key = contextMenu.tabKey;
    const tab = tabs.find(t => t.key === key);
    if (tab && tab.closable) {
      dispatch({
        type: 'remove-tab',
        payload: {
          key
        }
      });
      if (activeTab === key) {
        const remainingTabs = tabs.filter(t => t.key !== key);
        if (remainingTabs.length > 0) {
          history.push(`/${remainingTabs[remainingTabs.length - 1].key}`);
        } else {
          history.push('/');
        }
      }
    }
    closeContextMenu();
  };
  const handleCloseOther = () => {
    const key = contextMenu.tabKey;
    dispatch({
      type: 'close-other-tabs',
      payload: {
        key
      }
    });
    history.push(`/${key}`);
    closeContextMenu();
  };
  const handleCloseAll = () => {
    dispatch({
      type: 'close-all-tabs',
      payload: {}
    });
    history.push('/');
    closeContextMenu();
  };
  const handleRefresh = () => {
    const key = contextMenu.tabKey;
    dispatch({
      type: 'refresh-tab',
      payload: {
        key
      }
    });
    closeContextMenu();
  };
  const handleRefreshAll = () => {
    dispatch({
      type: 'refresh-all-tabs',
      payload: {}
    });
    closeContextMenu();
  };
  void handleRefreshAll; // 保留供后续使用

  const handleTogglePin = () => {
    const key = contextMenu.tabKey;
    dispatch({
      type: 'toggle-pin-tab',
      payload: {
        key
      }
    });
    closeContextMenu();
  };
  if (tabs.length === 0) return null;
  const contextMenuTarget = tabs.find(t => t.key === contextMenu.tabKey);
  return /*#__PURE__*/React.createElement(DndProvider, {
    backend: HTML5Backend
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tabBar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tabList
  }, tabs.map((tab, index) => /*#__PURE__*/React.createElement(DraggableTab, {
    key: tab.key,
    tab: tab,
    index: index,
    isActive: activeTab === tab.key,
    onClick: () => handleTabClick(tab),
    onClose: e => handleClose(e, tab),
    onContextMenu: e => handleContextMenu(e, tab.key),
    onReorder: (fromIndex, toIndex) => {
      dispatch({
        type: 'reorder-tabs',
        payload: {
          fromIndex,
          toIndex
        }
      });
    }
  }))), contextMenu.visible && /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenu,
    style: {
      left: contextMenu.x,
      top: contextMenu.y
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuItem,
    onClick: handleRefresh
  }, /*#__PURE__*/React.createElement(_IconRefresh, {
    className: styles.contextMenuIcon
  }), t['tab.context.refresh'] || '刷新'), /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuDivider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuItem,
    onClick: handleTogglePin
  }, /*#__PURE__*/React.createElement(_IconPushpin, {
    className: styles.contextMenuIcon
  }), contextMenuTarget?.pinned ? t['tab.context.unpin'] || '取消固定' : t['tab.context.pin'] || '固定标签'), /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuDivider
  }), contextMenuTarget?.closable !== false && /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuItem,
    onClick: handleCloseCurrent
  }, /*#__PURE__*/React.createElement(_IconClose, {
    className: styles.contextMenuIcon
  }), t['tab.context.closeCurrent'] || '关闭当前'), /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuItem,
    onClick: handleCloseOther
  }, /*#__PURE__*/React.createElement(_IconClose, {
    className: styles.contextMenuIcon
  }), t['tab.context.closeOther'] || '关闭其他'), /*#__PURE__*/React.createElement("div", {
    className: styles.contextMenuItem,
    onClick: handleCloseAll
  }, /*#__PURE__*/React.createElement(_IconClose, {
    className: styles.contextMenuIcon
  }), t['tab.context.closeAll'] || '关闭全部'))));
}
function DraggableTab({
  tab,
  index,
  isActive,
  onClick,
  onClose,
  onContextMenu,
  onReorder
}) {
  const ref = useRef(null);
  const [, drop] = useDrop({
    accept: ITEM_TYPE,
    hover(item, monitor) {
      if (!ref.current || item.key === tab.key) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      onReorder(dragIndex, hoverIndex);
      item.index = hoverIndex;
    }
  });
  const [{
    isDragging
  }, drag] = useDrag({
    type: ITEM_TYPE,
    item: () => ({
      index,
      key: tab.key
    }),
    collect: monitor => ({
      isDragging: monitor.isDragging()
    })
  });
  drag(drop(ref));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: `${styles.tabItem} ${isActive ? styles.active : ''} ${isDragging ? styles.dragging : ''}`,
    onClick: onClick,
    onContextMenu: onContextMenu
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.tabTitle
  }, tab.title), tab.closable !== false && /*#__PURE__*/React.createElement("span", {
    className: styles.closeIcon,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(_IconClose, null)));
}
export default TabBar;